/* eslint-disable no-return-assign */
const floatNumberRegexp = new RegExp(/[0-9]+([\.,][0-9]+)?/);

export const inputValidation = (e) => {
  const { value } = e.target;
  let stringNumber = value;
  if (floatNumberRegexp.test(stringNumber)) {
    if (stringNumber.indexOf(',') !== -1) stringNumber = stringNumber.replace(',', '.');
    if (stringNumber.indexOf(' ') !== -1)
      return (e.target.value = stringNumber.replace(/\s+/g, ''));
    if (stringNumber.search(/[a-zA-Z]+/g) !== -1)
      return (e.target.value = stringNumber.replace(/[a-zA-Z]+/g, ''));
    if (stringNumber.charAt(0) === '0' && stringNumber.charAt(1) === '0')
      return (e.target.value = 0);
    if (stringNumber.indexOf('.') !== -1 && stringNumber.split('.')[1].length > 3) {
      return (e.target.value = `${stringNumber.split('.')[0]}.${stringNumber
        .split('.')[1]
        .slice(0, 3)}`);
    }
    const number = +stringNumber;
    if (typeof number !== 'number') return (e.target.value = '');
    if (number > 10000) return (e.target.value = 9999);
    if (number < 0) return (e.target.value = 0);
    e.target.value = stringNumber;
  } else {
    e.target.value = '';
  }
};

export const onBlurValidation = (e, changeFunc) => {
  const { value, name } = e.target;
  const stringNumber = value;
  if (stringNumber.charAt(stringNumber.length - 1) === '.') {
    e.target.value = stringNumber.replace('.', '');
    changeFunc(e, 'cbgu', name);
  }

  let weight = [];
  if (stringNumber.length !== 0) weight = stringNumber.split('');
  if (stringNumber && weight[0] === '0' && weight[1] !== '.') {
    weight.splice(1, 0, '.');
    e.target.value = +weight.join('');
  }
  if (stringNumber && weight[0] === '.') {
    weight.splice(0, 0, '0');
    e.target.value = +weight.join('');
  }

  changeFunc(e, 'cbgu', name);
};



// WEBPACK FOOTER //
// ./src/utils/CBGUInputValidations.js